import { render } from "./FooterCont.vue?vue&type=template&id=2103bc2e"
const script = {}

import "./FooterCont.vue?vue&type=style&index=0&id=2103bc2e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__